import React from 'react';

const WhyThisRepo = () => {
  return (
    <div>
      <h3>Why I added this Repository/Article/Blog/PR?</h3>
    </div>
  );
};

export default WhyThisRepo;
